<template>
  <div>
    <officials-list
      title="Lista urzędników"
      :users="list"
      :count="count"
      @pagination="reloadList"
      @add="showAddModal"
      @edit="showEditModal"
      @delete="showDeleteDialog"
    ></officials-list>

    <modal :show="showModal" :id="idToEdit" :edit="!!idToEdit" @close="hideModal" @save="add" @update="update"></modal>

    <material-dialog
      title="Potwierdź usunięcie"
      :show="!!idToDelete"
      :id="idToDelete"
      :text="confirmDeleteText"
      @close="hideDeleteDialog"
      @confirm="remove"
    ></material-dialog>
  </div>
</template>

<script>
import { listMixin } from '@/mixins/list';
import MaterialDialog from '@/components/material/Dialog';
import Modal from './modals/Manage';
import OfficialsList from './subViews/OfficialsList';

/**
 * @vuese
 * @group Officials
 * Lista urzędników
 */
export default {
  components: { MaterialDialog, Modal, OfficialsList },
  mixins: [
    listMixin('officials', {
      listError: 'Wystąpił błąd podczas pobierania listy urzędników.',
      getError: 'Wystąpił błąd podczas pobierania danych urzędnika.',
      added: 'Dodano urzędnika.',
      addError: 'Nie udało się dodać urzędnika.',
      updated: 'Zaktualizowano dane urzędnika.',
      updateError: 'Nie udało się zaktualizować danych urzędnika.',
      deleted: 'Usunięto urzędnika.',
      deleteError: 'Nie udało się usunąć urzędnika.'
    })
  ],
  computed: {
    toDelete() {
      if (this.idToDelete) {
        return this.list.find(item => item.id === this.idToDelete);
      }
    },
    confirmDeleteText() {
      if (this.toDelete) {
        return `Czy napewno chcesz usunąć konto urzędnika ${this.toDelete.firstName} ${this.toDelete.lastName}?`;
      }
      return '';
    }
  }
};
</script>